import { jsx as _jsx } from "react/jsx-runtime";
import { AdBannerList, useAdBannerQuery } from ".";
//디폴트 배너
export const AdBanner = (param)=>{
    let { shape ="default" , position , subject , mixpanelPosition  } = param;
    const { adBannerResponse , noAdItems  } = useAdBannerQuery({
        position,
        subject
    });
    if (noAdItems) return null;
    return /*#__PURE__*/ _jsx(AdBannerList, {
        position: position,
        children: adBannerResponse.items.map((param)=>/*#__PURE__*/ {
            let { link , imageUrl , id  } = param;
            return _jsx(AdBannerList.Item, {
                link: link,
                imageUrl: imageUrl,
                shape: shape,
                id: id,
                mixpanelPosition: mixpanelPosition
            }, "adbanner-" + id);
        })
    });
};
